import * as React from "react"
import type { IconProps } from "../types"

const Branch = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, strokeWidth = 1.5, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          d="M7.5 8C8.88071 8 10 6.88071 10 5.5C10 4.11929 8.88071 3 7.5 3C6.11929 3 5 4.11929 5 5.5C5 6.88071 6.11929 8 7.5 8ZM7.5 8V12M16.5 8C17.8807 8 19 6.88071 19 5.5C19 4.11929 17.8807 3 16.5 3C15.1193 3 14 4.11929 14 5.5C14 6.88071 15.1193 8 16.5 8ZM16.5 8V12H7.5M7.5 16C6.11929 16 5 17.1193 5 18.5C5 19.8807 6.11929 21 7.5 21C8.88071 21 10 19.8807 10 18.5C10 17.1193 8.88071 16 7.5 16ZM7.5 16V12"
        />
      </svg>
    )
  }
)
Branch.displayName = "Branch"

export default Branch
